import * as React from "react";
import { ArrowRight, BookOpen, Newspaper } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const guidesData = [{
  id: "g1",
  title: "Manual Therapy Techniques",
  excerpt: "Discover how our hands-on approach to joint and soft tissue mobilization accelerates your natural healing process.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/manual_therapy_session.png",
  url: "/HealthInsightsPage"
}, {
  id: "g2",
  title: "Post-Surgical Rehabilitation",
  excerpt: "A comprehensive guide to navigating your recovery journey after orthopedic surgery with personalized care plans.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/rehab_recovery.png",
  url: "/HealthInsightsPage"
}, {
  id: "g3",
  title: "Ergonomics for Longevity",
  excerpt: "Learn essential workplace adjustments and movement habits to prevent chronic pain and improve daily posture.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/ergonomics_guide.png",
  url: "/HealthInsightsPage"
}];
const newsData = [{
  id: "n1",
  title: "Bodywerks Expands to New Nicosia Clinic",
  excerpt: "We are excited to bring our specialized physiotherapy and rehabilitation services to a brand new location in Nicosia.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/nicosia_clinic_opening.png",
  url: "/HealthInsightsPage"
}, {
  id: "n2",
  title: "New Sports Injury Protocol Launched",
  excerpt: "Integrating the latest biomechanical analysis technology to help athletes return to peak performance faster than ever.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/sports_injury_tech.png",
  url: "/HealthInsightsPage"
}, {
  id: "n3",
  title: "Managing Chronic Back Pain Naturally",
  excerpt: "Our clinical team shares evidence-based strategies for long-term relief without relying solely on medication.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/back_pain_relief.png",
  url: "/HealthInsightsPage"
}];
export default function GuidesAndNews() {
  return <section data-section-id="149548" id="why-choose-bodywerks" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center md:text-left">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-serif">
            Health Insights & Updates
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-sans">
            Expert advice, clinical guides, and the latest news from our specialized physiotherapy team.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-3 border-b border-border pb-4">
              <div className="flex size-10 items-center justify-center rounded-lg bg-accent/10 text-accent">
                <BookOpen className="size-5" />
              </div>
              <h3 className="text-2xl font-semibold text-foreground font-serif">Clinical Guides</h3>
            </div>
            
            <div className="flex flex-col gap-6">
              {guidesData.map((guide, i) => <Card key={guide.id} data-index={i} className="overflow-hidden border-none bg-slate-200 rounded-2xl shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-accent/5">
                  <img src={guide.image} alt={guide.title} className="h-48 w-full object-cover rounded-t-2xl" />
                  <CardHeader>
                    <CardTitle className="text-xl font-serif text-primary">{guide.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base font-sans text-secondary">
                      {guide.excerpt}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Button variant="link" asChild className="px-0 text-accent hover:text-accent/80">
                      <Link to={guide.url}>
                        Read guide <ArrowRight className="ml-2 size-4" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>)}
            </div>
            
            <div className="mt-2">
              <Button variant="outline" asChild className="w-full sm:w-auto rounded-full border-accent text-accent hover:bg-accent hover:text-white">
                <Link to="/HealthInsightsPage">View all guides</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-3 border-b border-border pb-4">
              <div className="flex size-10 items-center justify-center rounded-lg bg-accent/10 text-accent">
                <Newspaper className="size-5" />
              </div>
              <h3 className="text-2xl font-semibold text-foreground font-serif">Latest News</h3>
            </div>

            <div className="flex flex-col gap-6">
              {newsData.map((newsItem, i) => <Card key={newsItem.id} data-index={i} className="overflow-hidden border-none bg-slate-200 rounded-2xl shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-accent/5">
                  <img src={newsItem.image} alt={newsItem.title} className="h-48 w-full object-cover rounded-t-2xl" />
                  <CardHeader>
                    <CardTitle className="text-xl font-serif text-primary">{newsItem.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base font-sans text-secondary">
                      {newsItem.excerpt}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Button variant="link" asChild className="px-0 text-accent hover:text-accent/80">
                      <Link to={newsItem.url}>
                        Read article <ArrowRight className="ml-2 size-4" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>)}
            </div>

            <div className="mt-2">
              <Button variant="outline" asChild className="w-full sm:w-auto rounded-full border-accent text-accent hover:bg-accent hover:text-white">
                <Link to="/HealthInsightsPage">View all news</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}